import { render, staticRenderFns } from "./KubernetesCodeViewer.vue?vue&type=template&id=d000ef32&"
import script from "./KubernetesCodeViewer.vue?vue&type=script&lang=js&"
export * from "./KubernetesCodeViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports